<ion-item [button]="false" [disabled]="spin">
  <div class="me-3 my-2">
    <ng-container *ngIf="spin">
      <ion-thumbnail (click)="onClick()">
        <div class="border d-flex justify-content-center align-items-center text-break text-center" style="width: 80px;height: 80px;">
          <ion-spinner name="circular" color="medium"></ion-spinner>
        </div>
      </ion-thumbnail>
    </ng-container>
    <ng-container *ngIf="!spin">
      <ion-thumbnail (click)="_onClick()" *ngIf="isNotReady()">
        <div class="border d-flex justify-content-center align-items-center text-break text-center" style="width: 80px;height: 80px;">
          <ion-icon [color]="getPhotoColor(photo)" slot="start" name="camera-outline" size="large"></ion-icon>
        </div>
      </ion-thumbnail>
      <!-- <ion-thumbnail (click)="_onClick()" *ngIf="!isNotReady()">
        <img class="border" [src]="imageUrl" alt="">
      </ion-thumbnail> -->
      <div class="photo-thumbnail" (click)="_onClick()" *ngIf="!isNotReady()" [style.background-image]="imageUrlBackground">
        <!-- cover -->
      </div>
    </ng-container>
  </div>
  <span class="text-break">{{ 'APP.TYPE.' + photo?.type | translate }}</span>
  <div slot="end" class="d-flex align-items-center gap-2">
    <ion-icon color="danger" name="alert-circle-outline" *ngIf="error"></ion-icon>
    <ion-spinner name="circular" color="medium" *ngIf="spinAi"></ion-spinner>
    <img class="icon-ai" [src]="'./assets/images/icons/ai.png'" *ngIf="!spinAi">
    <!-- <ion-note class="text-small" *ngIf="!spinAi">{{ photo.photo_status | translate }}</ion-note> -->
    <!-- <span class="badge badge-pill fw-normal" [style.background-color]="status[photo.photo_status]?.background" [style.color]="status[photo.photo_status]?.color">{{ status[photo.photo_status]?.label | translate}}</span> -->
  </div>
</ion-item>
